import ToolBase from "../basic";
import DEFINE from "../define";

export default class Stamp extends ToolBase {

    name = DEFINE.TOOLS.STAMP

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        object.set({
            perPixelTargetFind: true,
            cornerColor: DEFINE.COLOR.CORNER_COLOR,
            hasBorders: false,
            transparentCorners: false,
            selectable: true,
            controls: Object.assign(this.getBasicControls(), {
                mtr: new fabric.Control({
                    visible: false
                }),
            }),
            toolType: this.name,
            lockScalingFlip: true,
            minScaleLimit: 0.5,
        })
    }

    create() {
    }

    mouseDown(o) {
        let pointer = this.canvas.getPointer(o.e);
        let imgUrl = this.parent.getStampImgUrl();
        let route = "./image/stamp/" + imgUrl;

        
        fabric.Image.fromURL(route, (oImage) => {
            oImage.scale(0.375);
            oImage.toolType = this.name;
            oImage.lockScalingFlip = true;
            oImage.minScaleLimit = 0.25;
            oImage.left = pointer.x - oImage.getScaledWidth() * 0.75;
            oImage.top = pointer.y - oImage.getScaledHeight() * 0.5;
            oImage.url = imgUrl;
            oImage.imageFileName = imgUrl;
            this.canvas.add(oImage);
            
            this.canvas.renderAll();
            
        });
    }

    objectAdded(o) {
        let target = o.target;

        target.tag = DEFINE.TAG.STAMP + new Date().getTime();
        target.cornerColor = DEFINE.COLOR.CORNER_COLOR;
        target.hasBorders = false;
        target.transparentCorners = false;
        target.selectable = true;
        target.controls = Object.assign(this.getBasicControls());

        this.parent.addHistory();
    }
}